import { BaseItem } from './baseItem'
import {ImageMeta} from './imageMeta'
/**
 * Class representing a content item
 */
export class ContentItem extends BaseItem {
  /**
   * Create a content item.
   * @param {String} options.name - The name of the item
   * @param {String} options.damageDesc - the description of what damage has been done
   * @param {Image} options.wholeItemImage
   */
  constructor (options) {
    if (options) {
      super(options.purchaseDate,
        options.areaOfDamageImages,
        options.receipt,
        options.currency,
        options.price)
      this.name = options.name
      this.damageDesc = options.damageDesc
      this.wholeItemImage = options.wholeItemImage
    } else {
      super()
    }
  }

  get name () {
    return this._name
  }

  set name (value) {
    if (value) this._name = String(value)
    else this._name = null
  }

  get damageDesc () {
    return this._damageDesc
  }

  set damageDesc (value) {
    if (value) this._damageDesc = String(value)
    else this._damageDesc = null
  }

  get wholeItemImage () {
    return this._wholeItemImage
  }

  set wholeItemImage (value) {
    if (value && !(value instanceof ImageMeta)) {
      throw new TypeError('wholeItemImage is not an instance of ImageMeta')
    }
    this._wholeItemImage = value
  }

  toJSON () {
    let json = super.toJSON()
    Object.assign(json, {
      name: this._name,
      damageDesc: this._damageDesc,
      wholeItemImage: this._wholeItemImage
    })
    return json
  }
}
